import { render, staticRenderFns } from "./Pgslot.vue?vue&type=template&id=4f6f4dcb&scoped=true"
import script from "./Pgslot.vue?vue&type=script&lang=js"
export * from "./Pgslot.vue?vue&type=script&lang=js"
import style0 from "./Pgslot.vue?vue&type=style&index=0&id=4f6f4dcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f4dcb",
  null
  
)

export default component.exports